export default "__VITE_ASSET__D$EyJZY8__"